import { TTheme } from '@/core/theme'
import { styled } from '@mui/material'
import { BannerVariant } from './InfoBanner.types'

export const BannerContainer = styled('div')<{
    theme?: TTheme
    variant?: BannerVariant
}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 15px 24px;
    background: ${({ theme, variant }) => {
        switch (variant) {
            case 'warning':
                return theme?.colors.semantic.bannerBackgroundWarning
            case 'error':
                return theme?.colors.semantic.bannerBackgroundError
            default:
                return theme?.colors.semantic.bannerBackgroundInfo
        }
    }};
    border-radius: 8px;
    border: 1px solid
        ${({ theme, variant }) => {
            switch (variant) {
                case 'warning':
                    return theme?.colors.semantic.bannerBorderWarning
                case 'error':
                    return theme?.colors.semantic.caseLightRedBorder
                default:
                    return theme?.colors.semantic.bannerBorderInfo
            }
        }};
`

export const BannerIcon = styled('div')<{
    theme?: TTheme
    variant?: BannerVariant
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${({ theme, variant }) =>
        variant === 'error'
            ? theme?.colors.semantic.bannerIconBackgroundError
            : theme?.colors.semantic.bannerIconBackground};
    border: 1px solid ${({ theme }) => theme?.colors.semantic.bannerIconBorder};
    filter: drop-shadow(0 0 8.242px rgba(22, 53, 88, 0.1));
    flex-shrink: 0;
`

export const BannerContent = styled('div')<{ theme?: TTheme }>`
    margin-right: 42px;

    .terms-link {
        color: ${({ theme }) => theme?.colors.primary[600]};
        text-decoration: none;
        font-weight: 500;
        transition: color 0.2s ease;

        &:hover {
            color: ${({ theme }) => theme?.colors.primary[700]};
            text-decoration: underline;
        }
    }
`

export const BannerActions = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`

export const IconAndContentContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 20px;
`
